import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Ticket.css";
import "./menu3.css";
axios.defaults.withCredentials = true;

const Setting = () => {
  const [, setActiveMenu] = useState(3);
  const navigate = useNavigate();
  const [editing, setEditing] = useState(false);
  const [error] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [addresses, setAddresses] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    position: "",
    phone: "",
    address: "",
    issueSummary: "",
    issueDetails: "",
    password: "",
    confirmPassword: "",
    fileupload: [],
    files: [],
    severityLevel: "",
    sla: "Platinum (7x24x4)",
  });

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get("/customer/me");
        setUserDetails(res.data.user);
      } catch (err) {
        console.error("Error fetching profile:", err);
      }
    };
    fetchProfile();
  }, [navigate]);

  useEffect(() => {
    if (userDetails) {
      setFormData((prev) => ({
        ...prev,
        name: userDetails.name || "",
        email: userDetails.email || "",
        company: userDetails.company || "",
        position: userDetails.position || "",
        phone: userDetails.phone || "",
      }));
      setAddresses(userDetails.addressList || []);
    }
  }, [userDetails]);

  const handleMenuChange = (menuId) => {
    setActiveMenu(menuId);
    if (menuId === 1) {
      navigate("/tickets");
    }
  };

  const handleFormInputChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleFormInputUpdate = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };
  const handleFormAddressUpdate = (index, value) => {
    setAddresses((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], address: value };
      return updated;
    });
  };

  const handleRemoveAddress = (index) => {
    setAddresses((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddNewAddress = () => {
    setAddresses((prevAddresses) => [
      ...prevAddresses,
      { id: null, address: "" },
    ]);
  };

  const startEditing = () => {
    setFormData({
      name: userDetails.name || "",
      email: userDetails.email || "",
      company: userDetails.company || "",
      position: userDetails.position || "",
      phone: userDetails.phone || "",
      address: "",
    });

    setAddresses(userDetails.addressList || []);
    setEditing(true);
  };

  const handleSave = async () => {
    if (
      !formData.company?.trim() ||
      !formData.name?.trim() ||
      !formData.position?.trim() ||
      !formData.phone?.trim() ||
      addresses.length === 0 ||
      addresses.some((addr) => !addr.address.trim())
    ) {
      alert("Please fill in all fields before saving.");
      return;
    }

    const isValidPhone = /^[0-9]{10}$/.test(formData.phone.trim());
    const isValidName = /^[A-Za-zก-ฮะ-์\s]+$/.test(formData.name.trim());

    if (!isValidPhone) {
      alert("Invalid phone number! It must be exactly 10 digits.");
      return;
    }

    if (!isValidName) {
      alert("Invalid name! It should not contain numbers.");
      return;
    }

    const updatedFormData = {
      Name: formData.name.trim(),
      Email: formData.email.trim(),
      Company: formData.company.trim(),
      Position: formData.position.trim(),
      Addresses: addresses.filter((a) => a.address.trim() !== ""),
      Phone: formData.phone.trim(),
    };

    try {
      await axios.post(`/customer/me`, updatedFormData, {
        headers: { "Content-Type": "application/json" },
      });

      alert("User details updated successfully!");
      setEditing(false);

      const response = await axios.get(`/customer/me`);
      setUserDetails(response.data.user);
    } catch (error) {
      console.error(
        " Error updating user details:",
        error.response?.data || error.message
      );
      alert("Failed to update user details.");
    }
  };

  const handleLogout = async () => {
    const ok = window.confirm("ยืนยันออกจากระบบ?");
    if (!ok) return;

    try {
      await axios.post(
        "/customer/logout",
        {},
        { withCredentials: true }
      );

      navigate("/home");
    } catch (err) {
      console.error("Logout failed:", err);
      alert("ออกจากระบบไม่สำเร็จ");
    }
  };
  return (
    <>
      <div className="ticket-container">
        <div className="ticket-sidebar">
          <div className="ticket-menu-header">Menu</div>
          <ul className="ticket-menu-list">
            <li className="ticket-menu-item">
              <button
                className="ticket-button3"
                onClick={() => handleMenuChange(1)}
              >
                Ticket
              </button>
            </li>
            <li className="ticket-menu-item">
              <button
                className="ticket-button3"
                onClick={() => navigate("/tickets/new")}
              >
                Open a New Ticket
              </button>
            </li>
            <li className="ticket-menu-item ticket-active">
              <button className="ticket-button3">Setting</button>
            </li>
            <li className="ticket-menu-item">
              <button className="ticket-button3" onClick={handleLogout}>
                ออกจากระบบ
              </button>
            </li>
          </ul>
        </div>
        <div
          className="user-info-container"
          style={{
            flex: 1,
            padding: "30px",
            maxWidth: "80%",
            backgroundColor: "#fff",
            height: "80%",
          }}
        >
          <h2 className="user-info-title">User Information</h2>
          {error && <p className="user-info-error">{error}</p>}
          {userDetails ? (
            <div className="user-info-details">
              {!editing ? (
                <>
                  <p className="user-info-item">
                    <strong>Name:</strong> {userDetails.name}
                  </p>
                  <p className="user-info-item">
                    <strong>Email:</strong> {userDetails.email}
                  </p>
                  <p className="user-info-item">
                    <strong>Company:</strong> {userDetails.company}
                  </p>
                  <p className="user-info-item">
                    <strong>Position:</strong> {userDetails.position}
                  </p>
                  <p className="user-info-item">
                    <strong>Phone:</strong> {userDetails.phone}
                  </p>
                  <p className="user-info-item">
                    <strong>Address:</strong> {userDetails.address}
                  </p>
                  <button
                    className="user-info-edit-button"
                    onClick={startEditing}
                  >
                    Edit
                  </button>
                </>
              ) : (
                <>
                  <div className="user-info-edit-group">
                    <label>Email:</label>
                    <input
                      type="email"
                      value={formData.email}
                      readOnly
                      className="user-info-edit-input"
                    />
                  </div>
                  <div className="user-info-edit-group">
                    <label>Company:</label>
                    <input
                      type="text"
                      value={formData.company}
                      readOnly
                      className="user-info-edit-input"
                    />
                  </div>
                  <div className="user-info-edit-group">
                    <label>Name:</label>
                    <input
                      type="text"
                      value={formData.name}
                      onChange={(e) =>
                        handleFormInputChange("name", e.target.value)
                      }
                      className="user-info-edit-input"
                    />
                  </div>
                  <div className="user-info-edit-group">
                    <label>Position:</label>
                    <input
                      type="text"
                      value={formData.position}
                      onChange={(e) =>
                        handleFormInputUpdate("position", e.target.value)
                      }
                      className="user-info-edit-input"
                    />
                  </div>
                  <div className="user-info-edit-group">
                    <label>Phone:</label>
                    <input
                      type="tel"
                      value={formData.phone}
                      onChange={(e) =>
                        handleFormInputUpdate("phone", e.target.value)
                      }
                      className="user-info-edit-input"
                    />
                  </div>
                  <div className="user-info-edit-group">
                    <label>Address:</label>
                    <div className="user-info-address-list">
                      {addresses.map((address, index) => (
                        <div key={index} className="user-info-address-item">
                          <div className="address-input-container">
                            <input
                              type="text"
                              value={address.address}
                              onChange={(e) =>
                                handleFormAddressUpdate(index, e.target.value)
                              }
                              className="user-info-edit-input"
                              placeholder={`Address ${index + 1}`}
                            />
                            <button
                              className="remove-address-button"
                              onClick={() => handleRemoveAddress(index)}
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                    <button
                      className="add-address-button"
                      onClick={handleAddNewAddress}
                    >
                      Add New Address
                    </button>
                  </div>

                  <button
                    className="user-info-save-button"
                    onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    className="user-info-cancel-button"
                    onClick={() => setEditing(false)}
                  >
                    Cancel
                  </button>
                </>
              )}
            </div>
          ) : (
            <p className="user-info-loading">Loading user details...</p>
          )}
        </div>
      </div>
    </>
  );
};

export default Setting;
